import React, { useEffect, useState } from 'react';
import {
  getMyProductsArtisansAction,
  updateMyArtisanProductAction
} from '../../../../modules/myProductList/Artisan/Actions';
import {
  artisanProductsSelector,
  artisanProductsIsLoadingSelector,
  searchValueSelector,
  artisanProductsCountSelector
} from '../../../../modules/myProductList/Artisan/Selectors';
import { connect } from 'react-redux';
import List from '../../../../components/Lists/List';
import ListItem from '../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { artisanDataSelector } from '../../../../modules/auth/Selectors';
import getLangData from '../../../../utils/getLangData';
import ProductComp from '../../../../components/UI/combine/ProductComp';
import { Button, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import EmptyPage from '../../../../components/DashboardLayout/StaticBar/EmptyPage';

const MyProductsList = props => {
  const {
    artisanProducts,
    artisanProductsIsLoading,
    getArtisanProducts,
    searchValue,
    artisanProductsCount,
    getArtisanProductsPictures,
    disableProduct,
    artisanData
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  // for testing only

  const artisanId = artisanData?._id;

  // console.log(artisanData, 'artisanData')
  useEffect(() => {
    getArtisanProducts({
      size,
      offset,
      searchTerm: searchValue,
      filterArtisan: artisanId
    });
    // getArtisanProductsPictures();
  }, [getArtisanProducts, searchValue]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (artisanProducts.length >= artisanProductsCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getArtisanProducts({
      size,
      offset: artisanProducts.length,
      searchTerm: searchValue,
      filterArtisan: artisanId
    });
  };

  //
  const dataLength =
    artisanProducts.length <= artisanProductsCount
      ? artisanProducts.length
      : artisanProductsCount;

  if (artisanProductsIsLoading) return <Spinner />;
  if (!artisanProductsIsLoading && artisanProducts?.length === 0) {
    return (
      <EmptyPage
        imageName='products.svg'
        title=''
        link='/my-artisan-products/create'
      ></EmptyPage>
    );
  }
  return (
    <InfiniteScroll
      next={fetchMore}
      hasMore={hasMore}
      dataLength={dataLength}
      style={{ overflow: 'hidden' }}
    >
      <ProductComp
        cardTitle={getLangData().menu.side.my_artisan_products}
        isLoading={artisanProductsIsLoading}
        items={artisanProducts}
        edit='/my-artisan-products'
      >
        <Link to='/my-artisan-products/create' className='btn btn-primary'>
          {getLangData().buttons.add_new}
        </Link>
      </ProductComp>
    </InfiniteScroll>
  );
  return (
    <InfiniteScroll
      next={fetchMore}
      hasMore={hasMore}
      dataLength={dataLength}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          isLoading={artisanProductsIsLoading}
          items={artisanProducts}
          header={{
            items: [getLangData().general_words.artisan_products],
            actions: ['Edit', 'Disable']
          }}
        >
          <table className='table'>
            <tbody>
              {artisanProducts.map(({ name, _id, email, status, hasStaging }) =>
                status ? (
                  <ListItem
                    key={_id}
                    name={name}
                    disabledText={status}
                    moderated={hasStaging}
                    description={email}
                    editLink={`/my-artisan-products/${_id}`}
                    // onSwich={() => disableProduct(_id, { status: false })}
                    // enable={status}
                    // onDelete={() => console.log(_id)}
                  ></ListItem>
                ) : (
                  <ListItem
                    key={_id}
                    disabledText={status}
                    moderated={hasStaging}
                    name={`${name}`}
                    description={email}
                    editLink={`/my-artisan-products/${_id}`}
                    // onSwich={() => disableProduct(_id, { status: true })}
                    // enable={status}
                    // onDelete={() => console.log(_id)}
                  ></ListItem>
                )
              )}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = state => ({
  artisanProducts: artisanProductsSelector(state),
  artisanProductsIsLoading: artisanProductsIsLoadingSelector(state),
  artisanProductsCount: artisanProductsCountSelector(state),
  searchValue: searchValueSelector(state),
  artisanData: artisanDataSelector(state)
});

export default connect(mapStateToProps, {
  getArtisanProducts: getMyProductsArtisansAction,
  // getArtisanProductsPictures: ,
  disableProduct: updateMyArtisanProductAction
})(MyProductsList);
